import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getEntityWithDesignation } from "src/util/functions/identifier"
import { IdentifierAssociationType } from "src/util/types/dataModels/identifier"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogIdentifierExists',
  props: {
  entityOldType: {
    type: String as PropType<IdentifierAssociationType>,
    required: true,
  },

  entityOldName: {
    type: String,
    required: true,
  },

  entityNewType: {
    type: String as PropType<IdentifierAssociationType>,
    required: true,
  },

  entityNewName: {
    type: String,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogHide, onDialogCancel, onDialogOK } = useDialogPluginComponent()

const oldEntity = computed(() => getEntityWithDesignation(props.entityOldType, props.entityOldName))
const newEntity = computed(() => getEntityWithDesignation(props.entityNewType, props.entityNewName))

const title = t("sfxDialogIdentifier.title_associate")
const previousAssociation = t("sfxDialogIdentifier.text1_associate", {
  entity_old: oldEntity.value,
})
const newAssociation = t("sfxDialogIdentifier.text2_associate", {
  entity_new: newEntity.value,
})
const btnCancel = t("sfxButtons.btn_cancel")
const btnChangeAssociation = t("sfxButtons.btn_association_change")

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 row justify-between" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(title)), 1),
              _createVNode(_component_q_icon, {
                name: _unref(Icons).INFORMATION
              }, null, 8, ["name"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("p", { innerHTML: _unref(previousAssociation) }, null, 8, _hoisted_2),
              _createElementVNode("p", { innerHTML: _unref(newAssociation) }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _unref(btnCancel),
                class: "col"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: _unref(btnChangeAssociation),
                class: "col"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})